"use client";

import clsx from "clsx";
import Link from "next/link";
import Icon, {ICON_SIZES, IconNameExtended} from "../library/Icon";
import {Card, CardContent} from "../ui/card";

interface JumpInCardProps {
   icon: IconNameExtended;
   title: string;
   description: string;
   href: string;
   iconClassName?: string;
   iconBgClassName?: string;
   hoverBorderClassName?: string;
}

export default function JumpInCard({
   icon,
   title,
   description,
   href,
   iconClassName,
   iconBgClassName,
   hoverBorderClassName,
}: Readonly<JumpInCardProps>) {
   return (
      <Link href={href} className={clsx("block", "group")}>
         <Card className={clsx("h-full", "shadow-none", "cursor-pointer", hoverBorderClassName)}>
            <CardContent className={clsx("p-4")}>
               <div
                  className={clsx(
                     "w-12",
                     "h-12",
                     "rounded-full",
                     iconBgClassName ?? "bg-panel_secondary",
                     "flex",
                     "items-center",
                     "justify-center",
                     "mb-4"
                  )}
               >
                  <Icon icon={icon} size={ICON_SIZES.LG} className={iconClassName} />
               </div>
               <h3 className={clsx("font-semibold", "text-900", "mb-1")}>{title}</h3>
               <p className={clsx("text-sm", "text-500")}>{description}</p>
            </CardContent>
         </Card>
      </Link>
   );
}
